import { environment } from "../../../environments/environment";
import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";


export const NewConfigurazioniModuli: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'Configurazione nomeModulo azienda:$descrizioneSoggetto',
      titleForm: 'Configurazione nomeModulo azienda:$descrizioneSoggetto',
      campoTitle: ['descrizioneSoggetto', 'nomeModulo'],
      helpDoc: 'ConfigurazioniModuloxFIR-RENTRi.html',
      service: 'ConfigurazioniModuli',
      api: 'ConfigurazioniModuli',
      filterList: '/',
      filterEditor: '/GetConfigurazioneByParams?nomeModulo=$nomeModulo&idSoggetto=$idSoggetto',
      formType: 'simple',
      template: 'form',
      nCol: 2,
      toolbarSettings: {
        service: 'soggetto',

      },


    },
  },
  {
    itemType: "group", colGroup: 6, colCount: 1, caption: 'Elenco Blocchi virtuali', groupDataField: 'configurazioneBlocchi', data: [
      {
        type: 'campo',
        dataField: 'visualizza',
        visible: true,
        dataType: 'number',
        editorType: 'dxSelectBox',
        class: 'crm_editor',
        caption: 'Visualizza',
        nCol: 4,
        lista: {
          isDefaultOption: false,
          dataSource: 'VivifirBlocchi',
          searchEnable: false,
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: false,
          queryString: '?idSoggetto=$idSoggetto',
        }
      },
    ]
  }
]

export const ConfigurazioniModuli: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'Configurazione nomeModulo azienda:$descrizioneSoggetto',
      titleForm: 'Configurazione nomeModulo azienda:$descrizioneSoggetto',
      campoTitle: ['descrizioneSoggetto', 'nomeModulo'],
      helpDoc: 'ConfigurazioniModuloxFIR-RENTRi.html',
      service: 'ConfigurazioniModuli',
      api: 'ConfigurazioniModuli',
      filterList: '/',
      filterEditor: '/GetConfigurazioneByParams?nomeModulo=$nomeModulo&idSoggetto=$idSoggetto',
      formType: 'simple',
      template: 'form',
      nCol: 2,
      toolbarSettings: {
        service: 'soggetto',

      },


    },
  },
  // {
  //   itemType: "group", colGroup: 4, caption: 'Dati Configurazione', colCount: 1, class: '', groupDataField: 'configurazione', data: [

  //     {
  //       type: 'campo',
  //       dataField: "user",
  //       colVisible: true,
  //       dataType: "",
  //       caption: "Client ID",
  //       validation: [
  //         { type: "required", message: "Client ID obbligatorio" }
  //       ],
  //       nCol: 10,


  //     },
  //     {
  //       type: 'campo',
  //       dataField: "numeroIscrizioneRentri",
  //       colVisible: true,
  //       dataType: "",
  //       readonly: true,
  //       disableOnUpdate: true,
  //       caption: "N.Iscrizione",
  //       validation: [
  //         { type: "required", message: "N.Iscrizione obbligatoria" }
  //       ],
  //       nCol: 10,


  //     },

  //     {

  //       type: 'campo', // il tipo di campo del form
  //       dataField: "certificato", // l'identificativo univoco del campo
  //       caption: "Certificato",
  //       nCol: 10,
  //       editorType: 'dxInputFile',

  //     },


  //     {
  //       type: 'campoPassword',
  //       dataField: "password",
  //       colVisible: false,
  //       dataType: "password",
  //       caption: "Client Secret",

  //       validation: [
  //         { type: "required", message: "Passowrd  Obbligatoria" }
  //       ],
  //       nCol: 10,
  //       maxLength: '255',
  //       class: 'passwordfied'
  //     },
  //     {
  //       type: 'campo', dataField: "url", colVisible: true, dataType: "", caption: "Url",
  //       validation: [
  //         { type: "required", message: "Url obbligatorio" }
  //       ],
  //       nCol: 10,
  //       maxLength: '255',

  //     },
  //     {
  //       type: 'campoData', dataField: "scadenza", colVisible: true, caption: "Data scadenza", format: "dd/MM/yyyy", editorType: "dxDateBox", dataType: "datetime", hideOnEdit: false,
  //       nCol: 4,

  //       validation: [
  //         { type: "required", message: "Scadenza obbligatorio" }
  //       ],
  //     },

  //     {
  //       type: 'campo',
  //       dataField: 'codicefiscale',
  //       dataType: 'string',
  //       caption: 'Codice Fiscale',
  //       nCol: 4
  //     },

  //     {
  //       type: 'campo',
  //       dataField: 'partitaIva',
  //       dataType: 'string',
  //       caption: 'Partita Iva',
  //       nCol: 4
  //     },

  //     {
  //       type: 'simpleButton', dataField: "syncViviVir",
  //       colVisible: false,
  //       nCol: 10,
  //       class: 'sync-button buttonGeneraFir blueButton',
  //       editorClass: '',
  //       button: {
  //         text: 'Conferma i paramentri di config.',
  //         name: "syncViviVir",
  //         event: "syncViviVir",
  //         type: "normal",
  //         hint: "Conferma i parametri di configurazione immessi, procedi con la syncronizzazione dei blocchi vivifir o xFir RENTRi",
  //         icon: "mdi mdi-sync",
  //       }
  //     },

  //     { type: 'campo', dataField: "modulo", colVisible: true, dataType: "", hideOnEdit: true },
  //     { type: 'campo', dataField: "idSoggetto", colVisible: true, dataType: "", hideOnEdit: true },
  //   ]
  // },
  {
    itemType: "group", colGroup: 6, colCount: 1, caption: 'Elenco Vidimazione', groupDataField: 'configurazioneBlocchi', data: [
      // itemType: "group", colGroup: 6, colCount: 1, caption: 'Elenco Blocchi/Posizione/Vidimazione', groupDataField: 'configurazioneBlocchi', data: [
      // {
      //   type: 'campoDesc', dataField: 'ViviFirDesc', dataType: '', defaultValue: 'ViviFir relativo solo alla categoria Spurghisti Art.230 comma 5'
      // },
      // {
      //   type: 'campo',
      //   dataField: 'visualizza',
      //   visible: true,
      //   defaultValue: 1,
      //   dataType: 'number',
      //   editorType: 'dxSelectBox',
      //   class: 'crm_editor',
      //   caption: 'Visualizza',
      //   nCol: 4,
      //   lista: {
      //     isDefaultOption: false,
      //     selectFirstElement: true,
      //     dataSource: '',
      //     searchEnable: false,
      //     valueExpr: 'key',
      //     displayExpr: 'value',
      //     static: true,
      //     items: [
      //       { key: 0, value: 'R.E.N.T.Ri' },
      //       { key: 1, value: 'ViviFir' },
      //     ]
      //   }

      // },
      // {
      //   type: 'campo',
      //   dataField: 'listVidimazione',
      //   visible: true,
      //   dataType: 'number',
      //   editorType: 'dxSelectBox',
      //   class: 'crm_editor',
      //   caption: 'Lista Vidimazione',
      //   nCol: 4,
      //   lista: {
      //     isDefaultOption: false,
      //     selectFirstElement: true,
      //     dataSource: '',
      //     searchEnable: false,
      //     valueExpr: 'key',
      //     displayExpr: 'value',
      //     static: false,
      //   }
      // },
      {
        type: 'campoGriglia', labelVisible: false, colSpan: "1", dataField: 'listaBlocchi',
        caption: 'Blocchi',
        colVisible: false,
        nCol: 10,
        showInColumnChooser: false,
        formGrid: {
          service: 'ViviFirBlocchiAzienda',
          api: '',
          remoteOperation: false,
          queryString: '',
          isEditable: true,
          isEditableNewRow: true,
          isEditableEditRow: true,
          isEditableDeleteRow: true,
          showToolbarTop: true,
          tableHeight: 450,
          tableWidth: 1000,
          showFilter: false,
          selectionRowMode: 'none',  // 'single' | 'detail' | 'multiple';
          idTable: '88888888888888888888888888888',
          isSearchable: false

        }


      },
    ]
  }
]


export const Configurazioni: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'nomeModulo azienda:$descrizioneSoggetto',
      titleForm: 'nomeModulo azienda:$descrizioneSoggetto',
      campoTitle: ['descrizioneSoggetto', 'nomeModulo'],
      helpDoc: 'ConfigurazioniModuloxFIR-RENTRi.html',
      // service: 'ConfigurazioniModuli',
      api: 'ConfigurazioniModuli',
      filterList: '/',
      filterEditor: '?idSoggetto=$idSoggetto',
      formType: 'simple',
      template: 'form',
      nCol: 2,
      toolbarSettings: {
        service: 'soggetto',

      },


    },
  },
  {
    itemType: "group", colGroup: 6, colSpan: 5, caption: 'Configurazione R.E.N.T.Ri', colCount: 3, class: '', groupDataField: 'configurazione_rentri', data: [

      {
        type: 'campo',
        dataField: "numeroIscrizioneRentri_rentri",
        colVisible: true,
        dataType: "",
        disabled: true,
        disableOnUpdate: true,
        class: 'opacity-100 me-2',
        caption: "N.Iscrizione",
        nCol: 4,
      },
      {

        type: 'campo',
        dataField: "certificato",
        caption: "Certificato",
        nCol: 4,
        fileAccepted: ['.p12'],
        class: 'd-flex align-items-center',
        customFileName: 'certificato_rentri.p12',
        editorType: 'dxInputFile',
        validation: [
          { type: "required", message: "Certificato R.E.N.T.Ri obbligatorio" }
        ],
      },
      { type: 'empty' },

      // { type: 'empty' },
      // { type: 'empty' },
      {
        type: 'campoPassword',
        dataField: "password_rentri",
        colVisible: false,
        dataType: "password",
        caption: "Password",
        nCol: 8,
        validation: [
          { type: "required", message: "Password R.E.N.T.Ri obbligatorio" }
        ],
        maxLength: '255',
        class: 'passwordfied'
      },
      { type: 'empty' },
      { type: 'empty' },

      {
        type: 'campo', dataField: "url_rentri",
        colVisible: true,
        dataType: "",
        caption: "Url",
        // disabled: true,
        // disableOnUpdate: true,
        // class: 'opacity-100',
        validation: [
          { type: "required", message: "Url R.E.N.T.Ri obbligatorio" }
        ],
        nCol: 8,
        maxLength: '255',

      },
      { type: 'empty' },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: 'codiceFiscale_rentri',
        dataType: 'string',
        caption: 'Codice Fiscale',
        disabled: true,
        disableOnUpdate: true,
        class: 'opacity-100 me-2',
        nCol: 2,
      },
      {
        type: 'campoData', dataField: "scadenza_rentri",
        colVisible: true,
        caption: "Data scadenza",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "datetime",
        disabled: true,
        showDropDownButton: false,
        disableOnUpdate: true,
        class: 'opacity-100',
        hideOnEdit: false,
        nCol: 2,

      },
      {
        type: 'campo',
        dataField: 'isRentriValido',
        dataType: 'string',
        caption: 'Configurazione Valida',
        editorType: 'iconStateVisual',
        class: 'opacity-100 align-items-center justify-content-center configValidation',
        nCol: 5,
        iconStateVisual: {
          type: 'custom',
          trueValue: 'si',
          falseValue: 'no',
          customFalse: {
            html: '<span>❌</span>',
            class: '',
            style: ''
          },
          customTrue: {
            html: '<span>✅</span>',
            class: 'configValidationIcon',
          }
        },


      },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },

    ]
  },
  { itemType: "group", colGroup: 10, class: 'mb-2', captionClass: 'd-none', data: [] },
  {
    itemType: "group", colGroup: 6, colSpan: 5, colCount: 2, caption: 'Configurazione Firma Remota', groupDataField: 'configurazione_firma', data: [
      {

        type: 'campo',
        dataField: "certificatoFirmaRemota",
        caption: "Certificato",
        nCol: 6,
        fileAccepted: ['.cer'],
        class: 'd-flex align-items-center me-2',
        customFileName: 'certificato_firma.cer',
        editorType: 'dxInputFile',
        validation: [],
      },
      {
        type: 'campoData', dataField: "scadenzaCertificatoFirmaRemota",
        colVisible: true,
        caption: "Data scadenza",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "datetime",
        disabled: true,
        showDropDownButton: false,
        disableOnUpdate: true,
        class: 'opacity-100',
        hideOnEdit: false,
        nCol: 2,

      },
    ]
  },
  { itemType: "group", colGroup: 10, class: 'mb-2', captionClass: 'd-none', data: [] },
  {
    itemType: "group", colGroup: 6, colSpan: 5, caption: 'Configurazione DH-WASTE', colCount: 5, class: '', groupDataField: 'configurazione_dh', data: [

      {
        type: 'campo',
        dataField: "user_dh",
        colVisible: true,
        dataType: "",
        caption: "Client ID",
        // validation: [
        //   { type: "required", message: "Client ID Dh-Waste obbligatorio" }
        // ],
        nCol: 8,
      },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      {
        type: 'campoPassword',
        dataField: "password_dh",
        colVisible: false,
        dataType: "password",
        caption: "Password",
        nCol: 8,
        // validation: [
        //   { type: "required", message: "Password Dh-Waste obbligatorio" }
        // ],
        maxLength: '255',
        class: 'passwordfied'
      },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: "url_dh",
        colVisible: true,
        dataType: "",
        caption: "Url",
        // disabled: true,
        // disableOnUpdate: true,
        class: 'opacity-100',
        nCol: 8,
        // validation: [
        //   { type: "required", message: "Url Dh-Waste obbligatorio" }
        // ],
        maxLength: '255',

      },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: 'company_dh',
        dataType: 'string',
        caption: 'Company',
        nCol: 2,
        width: '30px'
      },
      {
        type: 'campo',
        dataField: 'partitaIva_dh',
        dataType: 'string',
        caption: 'Partita Iva',
        disabled: true,
        disableOnUpdate: true,
        class: 'opacity-100',
        nCol: 2
      },
      {
        type: 'campo',
        dataField: 'isDHAttivo',
        dataType: 'string',
        caption: 'Configurazione Valida',
        editorType: 'iconStateVisual',
        class: 'opacity-100  justify-content-end',
        nCol: 3,
        iconStateVisual: {
          type: 'custom',
          trueValue: 'si',
          falseValue: 'no',
          customFalse: {
            html: '<span>❌</span>',
            class: '',
            style: ''
          },
          customTrue: {
            html: '<span>✅</span>'
          }
        },
        // iconStateVisual: {
        //   type: 'icon',
        //   trueValue: 'SI',
        //   falseValue: 'NO',
        // },
        // iconStateVisual: {
        //   type: 'icon',
        //   trueValue: true,
        //   falseValue: false,
        //   iconFalse: {
        //     iconClass: 'dx-icon-email'

        //   },
        //   iconTrue: {
        //     iconClass: 'dx-icon-email'
        //   }
        // },
      },
      { type: 'empty' },
      {
        type: 'simpleButton',
        dataField: "removeDhSaved",
        nCol: 1,
        class: 'justify-content-end',
        button: {
          text: '',
          name: "removeDhSaved",
          event: "removeDhSaved",
          type: "normal",
          hint: "Rimuovi la configurazione Dh-Waste salvata",
          icon: "dx-icon-trash",
        }
      },
      {
        type: 'campo',
        dataField: 'firmaDH',
        dataType: 'string',
        caption: 'Firma Valida',
        editorType: 'iconStateVisual',
        class: 'opacity-100 justify-content-end',
        nCol: 7,
        iconStateVisual: {
          type: 'custom',
          trueValue: 'si',
          falseValue: 'no',
          customFalse: {
            html: '<span>❌</span>'
          },
          customTrue: {
            html: '<span>✅</span>'
          }
        }
      },
      {
        type: 'campo',
        dataField: 'totFirme',
        dataType: 'number',
        editorType: 'dxNumberBox',
        caption: 'N.Firme',
        disabled: true,
        labelWidth: 60,
        disableOnUpdate: true,
        class: 'opacity-100 ',
        nCol: 1
      },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
    ]
  },
  { itemType: "group", colGroup: 10, class: 'mb-2', captionClass: 'd-none', data: [] },
  {
    itemType: "group", colGroup: 6, colSpan: 5, caption: 'Configurazione Vivifir - Art.230 c.5 - Spurghisti', colCount: 3, class: '', groupDataField: 'configurazione_vivifir', data: [

      {
        type: 'campo',
        dataField: "user_vivifir",
        colVisible: true,
        dataType: "",
        caption: "Client ID",
        // validation: [
        //   { type: "required", message: "Client ID Vivifir obbligatorio" }
        // ],
        nCol: 8,
      },
      { type: 'empty' },
      { type: 'empty' },
      {
        type: 'campoPassword',
        dataField: "password_vivifir",
        colVisible: false,
        dataType: "password",
        caption: "Password",
        nCol: 8,
        // validation: [
        //   { type: "required", message: "Password Vivifir obbligatorio" }
        // ],
        maxLength: '255',
        class: 'passwordfied'
      },
      { type: 'empty' },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: "url_vivifir",
        colVisible: true,
        dataType: "",
        // validation: [
        //   { type: "required", message: "Url Vivifir obbligatorio" }
        // ],
        caption: "Url",
        nCol: 8,
        maxLength: '255',

      },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      // {
      //   type: 'campoData', dataField: "scadenza_vivifir",
      //   colVisible: true,
      //   caption: "Data scadenza",
      //   format: "dd/MM/yyyy",
      //   editorType: "dxDateBox",
      //   dataType: "datetime",
      //   showDropDownButton: false,
      //   hideOnEdit: false,
      //   disabled: true,
      //   disableOnUpdate: true,
      //   class: 'opacity-100',
      //   nCol: 3,
      // },
      {
        type: 'campo',
        dataField: 'isVivifirValido',
        dataType: 'string',
        caption: 'Configurazione Valida',
        editorType: 'iconStateVisual',
        class: 'd-flex align-items-center justify-content-end',
        nCol: 7,
        iconStateVisual: {
          type: 'custom',
          trueValue: 'si',
          falseValue: 'no',
          customFalse: {
            html: '<span>❌</span>',
            class: '',
            style: ''
          },
          customTrue: {
            html: '<span>✅</span>'
          }
        },
      },
      {
        type: 'simpleButton',
        dataField: "removeVivifirSaved",
        class: 'justify-content-end',
        nCol: 1,
        button: {
          text: '',
          name: "removeVivifirSaved",
          event: "removeVivifirSaved",
          type: "normal",
          hint: "Rimuovi la configurazione Vivifir salvata",
          icon: "dx-icon-trash",
        }
      },
      { type: 'empty' },
    ]
  },
]